export default __webpack_public_path__ + "static/thousands of resources@3x-dfc186622f819f07f5db0d16c1d93ab7.png";